import React from "react";
import group from "../assets/Group2.png";

const PaymentRecharge = () => {
  return (
    <div className="container py-lg-5 py-3 responsives">
      <div className="row align-items-center justify-content-center mb-md-5 mb-0 flex-wrap-reverse flex-md-nowrap">
        {/* Left Image Section */}
        <div className="col-md-6 d-flex justify-content-center position-relative mb-4 mb-md-0 payment-image-area">
          <img
            src={group}
            className="payment-img img-fluid"
            alt="payment-img"
          />
        </div>

        {/* Right Text Section */}
        <div className="col-md-6 text-center text-md-start">
          <h2 className="payment-title">
            Mobile Recharge &amp; Bill Payments.
          </h2>

          <p className="payment-text">
            AEPSPay service allows customers to perform essential banking
            transactions using only their Aadhaar number and fingerprint
            authentication. With AEPS, we bring banking services closer to rural
            and urban communities, ensuring financial inclusion and effortless
            access to cash and account-related facilities.
          </p>

          <div className="d-flex flex-column flex-sm-row gap-3 mt-4 payment-btns justify-content-center justify-content-md-start">
            <a href="#" className="store-btn google-btn">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Google Play"
                className="store-img"
              />
            </a>

            <a href="#" className="store-btn apple-btn">
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="App Store"
                className="store-img"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentRecharge;
